export const Globals = {
    Title: "projectideas",
};
